import { Component } from '@theme/component';
import { QuantitySelectorUpdateEvent } from '@theme/events';

class QuantitySelectorComponent extends Component {
  connectedCallback() {
    super.connectedCallback?.();

    const input = this.refs.quantityInput;

    if (input) {
      let quantity=input.getAttribute('quant-set');
      input.removeAttribute('max');      // max helemaal weg
      
      console.log("quantity==============>",quantity)
      if(quantity){
        input.setAttribute('min', quantity);    // min 2
        input.setAttribute('step', quantity);   // stap 2
      } else{
        input.setAttribute('min', '2');    // min 2
        input.setAttribute('step', '2');   // stap 2
      }
      

      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'max') {
            input.removeAttribute('max');  // blijf max verwijderen
            console.log('max attribuut werd toegevoegd en is verwijderd');
          }
        });
      });

      observer.observe(input, { attributes: true });
      this._maxObserver = observer;
    }
  }

  increaseQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return;

    event.preventDefault();
    this.refs.quantityInput.stepUp();
    this.#onQuantityChange(event);
  }

  decreaseQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return;

    event.preventDefault();
    this.refs.quantityInput.stepDown();
    this.#onQuantityChange(event);
  }

  selectInputValue(event) {
    const { quantityInput } = this.refs;
    if (!(event.target instanceof HTMLInputElement) || document.activeElement !== quantityInput) return;

    quantityInput.select();
  }

  setQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return;

    event.preventDefault();
    if (event.target instanceof HTMLInputElement) {
      console.log("event.target.value========setQuantity============>",event.target.value)
      this.refs.quantityInput.value = event.target.value;
    }
    this.#onQuantityChange(event);
  }

  #onQuantityChange(event) {
    const { quantityInput } = this.refs;

    this.#checkQuantityRules();
    const newValue = parseInt(quantityInput.value);

    console.log("newValue========onQuantityChange============>",newValue,quantityInput.value)
    quantityInput.dispatchEvent(new QuantitySelectorUpdateEvent(newValue, Number(quantityInput.dataset.cartLine)));
  }

  #checkQuantityRules = () => {
    const { quantityInput } = this.refs;
    let min = parseInt(quantityInput.getAttribute('min'));
    let quantity=quantityInput.getAttribute('quant-set');

     console.log("quantity========checkQuantityRules============>",quantity)
    if(quantity){
       min=quantity
      }
      console.log("min========checkQuantityRules============>",min)
    let val = parseInt(quantityInput.value);

    console.log("val========checkQuantityRules============>",val,quantityInput.value)
    if (val < min && min) quantityInput.value = min;
    // Geen max check hier!
  };

  get quantityInput() {
    if (!this.refs.quantityInput) {
      throw new Error('Missing <input ref="quantityInput" /> inside <quantity-selector-component />');
    }

    return this.refs.quantityInput;
  }
}

if (!customElements.get('quantity-selector-component')) {
  customElements.define('quantity-selector-component', QuantitySelectorComponent);
}
